<template>
<div>
  <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3 mb-3">

    <vs-button  class="mr-3" @click="onHint" color="success">힌트보기</vs-button>

    <div class="btn-group">
      <!-- <vs-button  @click="onPrev" color="success">이전</vs-button> -->
      <vs-button  @click="onNext" color="success">다음</vs-button>
      <vs-button @click="onReload">재실행</vs-button>
      <vs-button  @click="onFinish" color="danger">종료</vs-button>
    </div>
  </vs-row>
</div>
</template>

<script>

export default {
  components: {
  },
  data () {
    return {
    }
  },
  watch: {
    
  },
  computed: {
    
  },
  methods: {
    onReload () {
      this.$emit('onReload')
    },
    onNext () {
      this.$emit('onNext')
    },
    onFinish () {
      this.$emit('onFinish')
    },
    onHint () {
      this.$emit('onHint')
    },
    onPrev () {
      this.$emit('onPrevious')
    }
  },
  created () {
    
  },
  beforeUpdate () {

  },
  beforeDestroy () {

  },
  mounted () {

  }
}

</script>
